import { colors, font } from 'framework/theme/constants/colors';
import { font_theme } from 'framework/theme/constants/font';

import { CalendarTheme } from './types';

export const calendar_theme: Pick<CalendarTheme, 'general'> = {
  general: {
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_normal,
    border_radius: '4px',
  },
};

export const calendar_dark_theme: CalendarTheme = {
  general: calendar_theme.general,
  background: {
    normal: colors.purple[8],
    boundary: colors.dark[7], // hover betweeen
    between: colors.dark[7], // hover betweeen
    hover: colors.purple[8],
    active: colors.purple[9], // selected
    disabled: colors.dark[8],
  },
  color: {
    normal: font.dark.normal, //default
    boundary: colors.dark[3], // outliers
    between: font.dark.normal, // between
    hover: colors.purple[9],
    active: font.dark.normal, // selected
    disabled: colors.light[10],
  },
};

export const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
